export interface IJournalToolsInfo {
  title: string;
  children?: React.ReactNode;
}

export const JournalToolsInfo = ({ title, children }: IJournalToolsInfo) => {
  return (
    <div className="mb-[20px]">
      <h2 className="font-comfortaa font-semibold text-lg lg:text-xl text-blackBase mb-[10px]">{title}</h2>
      {children}
    </div>
  );
};
